import type { FC } from "react"
import React from "react"
import { Button, Flex, HStack, Icon, Stack, Text } from "@chakra-ui/react"

import SwapRecipe from "createProposal/components/actions/SwapRecipe"
import type { Action } from "createProposal/action/types"
import { ExecutableCallType } from "query/graphql"
import ManageOrcaPodAction from "createProposal/action/ManageOrcaPodAction"
import TransferNativeAssetAction from "createProposal/action/TransferNativeAssetAction"
import TransferErc20Action from "createProposal/action/TransferErc20Action"
import CustomAction from "createProposal/action/CustomAction"
import RecipeSelector from "createProposal/components/actions/RecipeSelector"
import CustomRecipe from "createProposal/components/actions/CustomRecipe"
import TransferTokensRecipe from "createProposal/components/actions/TransferTokensRecipe"
import ManageOrcaPodRecipe from "createProposal/components/actions/ManageOrcaPodRecipe"
import SwapAction from "createProposal/action/SwapAction"
import TransferArbitrumErc20Action from "createProposal/action/TransferArbitrumErc20Action"
import TransferArbitrumNativeAssetAction from "createProposal/action/TransferArbitrumNativeAssetAction"
import CardContainer from "common/components/CardContainer"
import { Trash } from "ui/components/icons/font-awesome/solid/Trash"

type CreateProposalActionFormProps = {
  action: Action
  index: number
  isRemoveActionDisabled: boolean
  handleRemoveActionClick: () => void
  timelockId: string | undefined | null
  chainId: string
}

const CreateProposalActionForm: FC<CreateProposalActionFormProps> = ({
  action,
  index,
  isRemoveActionDisabled,
  handleRemoveActionClick,
  timelockId,
  chainId,
}) => {
  const { recipe } = action

  const shouldDisplaySelector =
    recipe === undefined || recipe === ExecutableCallType.Empty
  const shouldDisplayCustomRecipe = action instanceof CustomAction
  const shouldDisplayManageOrcaPodRecipe = action instanceof ManageOrcaPodAction
  const shouldDisplayTokenTransferRecipe =
    action instanceof TransferNativeAssetAction ||
    action instanceof TransferErc20Action ||
    action instanceof TransferArbitrumErc20Action ||
    action instanceof TransferArbitrumNativeAssetAction
  const shouldDisplaySwapRecipe = action instanceof SwapAction

  const handleRemoveAction = () => {
    handleRemoveActionClick()
  }

  return (
    <Stack spacing={12}>
      <Stack color="purple.900" spacing={4}>
        <Stack spacing={4}>
          <Flex align="center" justify="space-between" pl={2}>
            <Text color="purple.500" textStyle="body.bold.lg">
              Action #{index + 1}
            </Text>

            <HStack>
              <Button
                isDisabled={isRemoveActionDisabled}
                leftIcon={<Icon as={Trash} />}
                size="sm"
                variant="secondary"
                onClick={handleRemoveAction}
              >
                Remove action
              </Button>
            </HStack>
          </Flex>
          <CardContainer pt={0}>
            {shouldDisplaySelector && (
              <RecipeSelector
                chainId={chainId}
                index={index}
                timelockId={timelockId}
              />
            )}
            {shouldDisplayCustomRecipe && (
              <CustomRecipe action={action} index={index} />
            )}
            {shouldDisplayTokenTransferRecipe && (
              <TransferTokensRecipe action={action} index={index} />
            )}
            {shouldDisplayManageOrcaPodRecipe && (
              <ManageOrcaPodRecipe
                action={action}
                chainId={chainId}
                index={index}
                timelockId={timelockId}
              />
            )}
            {shouldDisplaySwapRecipe && (
              <SwapRecipe action={action} index={index} />
            )}
          </CardContainer>
        </Stack>
      </Stack>
    </Stack>
  )
}

export default CreateProposalActionForm
